import React, { useState, useRef, useEffect } from "react";
import { Formik, Form, ErrorMessageProps } from "formik";
import { RBButton } from "../../components/RBButton";
import { makeStyles, Link, IconButton, Typography, colors, Select, MenuItem, Box, Button, TextField, InputAdornment, Paper, FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox, InputLabel, useTheme, useMediaQuery, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, TableSortLabel, withStyles, Input } from "@material-ui/core";
import {
    Spacing,
    AppContainerWidth,
    Colors,
    FontSize,
} from "../../theme/Theme";
import { RoutePathConstant } from "../../util/Common";
import { RBCardView } from "../../components/RBCardView";
import { RouteComponentProps, useLocation, withRouter } from "react-router";
import { useRouteMatch, useHistory, useParams } from "react-router-dom";
import { AuthService } from "../../api/AuthService";
import { CircularProgress } from '@material-ui/core';
import { AlertInfoProps } from "../../interfacesProps/AlertInfoProps";
import { RBAlert } from "../../components/RBAlert";
import queryString from 'query-string';
import SearchIcon from '@material-ui/icons/Search';
import RoomIcon from '@material-ui/icons/Room';
import ClearIcon from '@material-ui/icons/Clear';
import Papa from 'papaparse';
import { format } from 'date-fns';
import moment from 'moment-timezone';


type Role = {
    workerType: string;
    displayName: string;
    orderSort?: number | null;
    // add other fields if needed
};

interface JobRow {
    opportunityNumber: string;
    startDate: string;
    rawDate: Date | null;
    opportunityType: string;
    positionType: string;
    wageRate: string;
    description: string;
    city: string;
    province: string;
    country: string;
}
interface OpportunityRow {
    [key: string]: string | number | Date | null | undefined;
}



export const Opportunities = ({ ...props }) => {
    const match = useRouteMatch<{ networkId: string, industry: string }>();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    let industryParam = queryParams.get('industry') || '';

    const [isLoading, setIsLoading] = useState(false);
    const [networkId, setNetworkId] = useState(match.params.networkId);
    const [brandDetail, setBrandDetail] = useState<any>(null);
    const [primaryColor, setPrimaryColor] = useState('');
    const [secondaryColor, setSecondaryColor] = useState('');
    const [selectedRole, setSelectedRole] = useState<string>('');
    const [roles, setRoles] = useState<Role[]>([]);
    const [selectedStartDate, setSelectedStartDate] = useState<string>('');
    const [selectedOpportunity, setSelectedOpportunity] = useState<string>('');
    const [selectedWage, setSelectedWage] = useState<string>('');
    const [opportunitySearch, setOpportunitySearch] = useState<string>('');
    const [rows, setRows] = useState<OpportunityRow[]>([]);
    const [hasError, setHasError] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState<'asc' | 'desc'>('asc');
    const [orderBy, setOrderBy] = useState<string>(''); // field to sort by
    const [roleSearch, setRoleSearch] = useState('');
    const [allRows, setAllRows] = useState<OpportunityRow[]>([]);
    const [locationSearch, setLocationSearch] = useState('');
    const [industryModes, setIndustryModes] = useState<any[]>([]);
    const [selectedIndustryMode, setSelectedIndustryMode] = useState<string>(industryParam || '');


    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

    const useStyles = makeStyles((theme) => ({
        container: {
            display: isMobile ? '' : 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            maxWidth: '100vw',   // ✅ prevents overflow
            padding: Spacing.larger,
            boxSizing: 'border-box',
        },

        formContainer: {
            position: 'relative',
            width: '100%',
            maxWidth: 600,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: 100,
            paddingBottom: 32,
            paddingLeft: 24,
            paddingRight: 24,
            boxSizing: 'border-box',
            textAlign: 'center',
            [theme.breakpoints.down('sm')]: {
                paddingTop: theme.spacing(10), // responsive top padding
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
            },
        },

        logo: {
            width: "180px",
            height: "auto",
            objectFit: "contain",
            display: "block",
            margin: 0,
            padding: 0,
            [theme.breakpoints.down('xs')]: {
                width: '140px',   // shrink further for very small screens
            },

        },
        topText: {
            textAlign: 'center',
            paddingLeft: 16,
            paddingRight: 16,
            color: 'black',
            fontSize: '1.4rem',
            [theme.breakpoints.up('sm')]: {
                paddingLeft: 32,
                paddingRight: 32,
            },
        },
        bottomText: {
            textAlign: 'center',
            paddingLeft: 20,
            paddingRight: 20,
            color: 'black',
            marginTop: 20,
            fontSize: '1.4rem',
            '@media (min-width: 600px)': {
                paddingLeft: 150,
                paddingRight: 150,
            },
        },
        textField: {
            '& label.Mui-focused': {
                color: 'grey',
            },
            '& .MuiInput-underline:hover:before': {
                borderBottomColor: primaryColor,
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: primaryColor,
            },
            '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                    border: `2px solid ${primaryColor}`
                },
                '&.Mui-focused fieldset': {
                    borderColor: `${primaryColor} !important`,
                },
            },
        },
        tableWrapper: {
            width: '100%',
            overflowX: 'auto',       // ✅ horizontal scroll
            '-webkit-overflow-scrolling': 'touch', // smooth scroll on iOS
        },
        filterItem: {
            [theme.breakpoints.down('xs')]: {
                flex: '1 1 100%',
            },
            [theme.breakpoints.up('sm')]: {
                flex: '0 1 280px',
            },
            margin: theme.spacing(1),
        },
        button: {
            height: 40,
            margin: 8,
            textTransform: 'none',
            backgroundColor: primaryColor + ' !important',
            fontWeight: 600,
            fontSize: '0.95rem',
            paddingLeft: 16,
            paddingRight: 16,
        },
        logoWrapper: {
            position: 'absolute',
            top: 16,
            right: 16,
            padding: 8,
            borderRadius: 4,
        },
        heading: {
            color: primaryColor,
            fontWeight: 600,
            textAlign: 'center',
            marginTop: brandDetail?.emailLogo ? 60 : 0, // add top margin if logo is present
        },

    }));


    const history = useHistory();
    const classes = useStyles();

    const columns = [
        { id: 'opportunityNumber', label: 'Opportunity #' },
        { id: 'startDate', label: 'Start Date' },
        { id: 'opportunityType', label: 'Opportunity Type' },
        { id: 'positionType', label: 'Position Type' },
        { id: 'wageRate', label: 'Wage Rate' },
        { id: 'description', label: 'Description' },
        { id: 'city', label: 'City' },
        { id: 'province', label: 'Province' },
        { id: 'country', label: 'Country' },
    ];


    const CustomInput = withStyles({
        underline: {
            '&:before': {
                borderBottom: '1px solid rgba(0, 0, 0, 0.42)', // default
            },
            '&:hover:not(.Mui-disabled):before': {
                borderBottom: `2px solid ${primaryColor}`, // hover with neutral color
            },
            '&:after': {
                borderBottom: (props: any) =>
                    props.value === ''
                        ? '1px solid rgba(0, 0, 0, 0.42)'
                        : `2px solid ${primaryColor}`, // focus with value only
            },
        },
    })(Input);

    // For InputLabel (unchanged)
    const CustomInputLabel = withStyles(() => ({
        root: {
            color: 'rgba(0, 0, 0, 0.6)',
            '&.Mui-focused': {
                color: primaryColor,
            },
            '&.MuiInputLabel-shrink': {
                transform: 'translate(0, 1.5px) scale(0.75)',
            },
        },
    }))(InputLabel);

    const opportunityOptions = [
        { label: 'Temp', value: 'Temp' },
        { label: 'Full Time', value: 'Full-time' },
        { label: 'Part Time', value: 'Part-time' },
        { label: 'Contract', value: 'Contract' },
    ];

    useEffect(() => {
        const fetchBrandDetail = async () => {
            try {
                setIsLoading(true);
                setHasError(false);
            
                let detail = await AuthService.brandDetail(networkId ? networkId : '7b89c1df-df98-41e8-a06c-f3d1d748de84');
                setBrandDetail(detail);
                setPrimaryColor(detail.primaryColor);
                setSecondaryColor(detail.secondaryColor);
                const response = await AuthService.getIndustryModes() // Replace with actual API
                setIndustryModes(response.data);

                const validIndustry = response.data.find(
                    (mode: any) => mode.industryMode === industryParam
                );
                if (validIndustry) {
                    setSelectedIndustryMode(industryParam);
                } else {
                    setSelectedIndustryMode(''); // invalid param → empty selection
                }

                let s3URl;
                if (process.env.REACT_APP_MODE === 'production') {
                    s3URl = 'https://relief-buddy-production.s3.ca-central-1.amazonaws.com/job-board-prod/job-board.csv'
                }
                else {
                    s3URl = 'https://relief-buddy-development.s3.ca-central-1.amazonaws.com/job-board-dev/job-board.csv'
                }
                Papa.parse(
                    s3URl,
                    {
                        download: true,
                        header: true,
                         dynamicTyping: (field: string | number) => field !== 'startDate',
                        // dynamicTyping: { startDate: false } ,
                        skipEmptyLines: true,
                        complete: (results: any) => {
                            let filtered = results.data
                                .filter((r: any) => networkId ? r.networkId === networkId : true)
                                .map((r: any) => {
                                    console.log("r. ==", r)
                                    console.log("r.locationtime zone ==", r.locationTimeZone)
                                    let wage = `$${Number(r.wageRate / 100).toFixed(2)}`;;
                                    if (r.wageRate === 0) {
                                        wage = 'Open Offer';
                                    }
                                     // ----- FIXED DATE HANDLING -----
              let m = null;
              if (r.startDate) {
                const tz = r.locationTimeZone || 'America/Toronto';

                if (r.opportunityNumber?.startsWith('J-')) {
                  // estStartDate is YYYY-MM-DD → parse as midnight in location tz
                  m = moment.tz(r.startDate, 'YYYY-MM-DD', tz);
                } else {
                  // other rows may have full datetime → parse in job tz
                  m = moment.tz(r.startDate, tz);
                }
              }

              const rawDate = m ? m.toDate() : null;

              let formattedDate = '';
              if (m) {
                if (r.opportunityNumber?.startsWith('J-')) {
                  formattedDate = m.format('MMM-DD-YYYY');
                } else {
                  const local = m;
                  formattedDate =
                    local.format('HH:mm') === '00:00'
                      ? local.format('MMM-DD-YYYY')
                      : local.format('MMM-DD-YYYY h:mm A');
                }
              }

                                   
                                    return {
                                        opportunityNumber: r.opportunityNumber,
                                        startDate: formattedDate,
                                        opportunityType: r.opportunityType,
                                        positionType: r.positionType,
                                        positionTypeDisplayName: r.positionTypeDisplayName,
                                        wageRate: `${wage}`,
                                        description: r.opportunityNumber.startsWith('S-')
                                            ? '(Viewable In App)'
                                            : r.description && r.description.length > 250
                                                ? r.description.substring(0, 250) + '… (Full Description Available in App)'
                                                : r.description,

                                        city: r.city,
                                        province: r.province,
                                        country: r.country,
                                        rawDate,
                                        wage: r.wageRate,
                                        industry: r.industry
                                    };
                                })
                                
                                .sort((a: any, b: any) => {
                                    return new Date(a.rawDate).getTime() - new Date(b.rawDate).getTime();
                                });

                            setAllRows(filtered);
                            // Remove rawDate before setting rows (optional)
                            //const finalRows = filtered.map(({ rawDate, ...rest }: { rawDate: any;[key: string]: any }) => rest);
                                console.log("filtered ==", filtered)
                            if (industryParam) {
                                filtered = filtered.filter((row: any) => row.industry === industryParam);
                            }
                            setRows(filtered);
                        }
                    }
                );

            } catch (error) {
                console.error("Failed to fetch brand detail", error);
                setHasError(true);
            } finally {
                setIsLoading(false);
            }
        };

        fetchBrandDetail();



    }, [networkId]);

    useEffect(() => {
        async function fetchRoles() {
            const getAllWorkers = await AuthService.getAllWorkerTypes();
            const sortedDataArray = getAllWorkers.sort(
                (a: Role, b: Role) => (a.orderSort || 0) - (b.orderSort || 0)
            );
            setRoles(sortedDataArray);
        }
        fetchRoles();
    }, []);

    const handleSearchWithValues = ({
        role,
        location,
        opportunity,
        selectedRole,
        selectedStartDate,
        selectedOpportunity,
        selectedWage,
        selectedIndustryMode
    }: {
        role: string;
        location: string;
        opportunity: string;
        selectedRole: string;
        selectedStartDate: string;
        selectedOpportunity: string;
        selectedWage: string;
        selectedIndustryMode: string;
    }) => {
        const lowerRole = role.toLowerCase().trim();
        const lowerLocation = location.toLowerCase().trim();
        const trimmedOpportunity = opportunity.trim();
        const lowerSelectedOpportunity = selectedOpportunity.toLowerCase().trim();


        const filtered = allRows.filter(row => {
            const position = row.positionType || '';
            const positionFullName = row.positionTypeDisplayName || '';
            const city = row.city || '';
            const province = row.province || '';
            const opportunityNumber = row.opportunityNumber?.toString() || '';
            const opportunityType = row.opportunityType || '';
            const industry = row.industry || '';

            const matchesIndustry =
        selectedIndustryMode === '' || industry === selectedIndustryMode;
            // ----- SAFE: derive tz as a string per-row (fallback to Toronto) -----
            const tz: string =
                typeof row.locationTimeZone === 'string' && row.locationTimeZone.trim()
                    ? row.locationTimeZone
                    : 'America/Toronto';

            // today in the job's timezone, start of day
            const today = moment().tz(tz).startOf('day');

            // moment for the row's rawDate in the same tz (if rawDate exists)
            const rowDate = row.rawDate ? moment(row.rawDate).tz(tz) : null;

            const wage = Number(row.wage);

            const matchesRole =
                (lowerRole === '' ||
                    (typeof position === 'string' && position.toLowerCase().includes(lowerRole)) ||
                    (typeof positionFullName === 'string' && positionFullName.toLowerCase().includes(lowerRole))
                ) &&
                (selectedRole === '' || (typeof position === 'string' && position.toLowerCase().includes(selectedRole.toLowerCase())));

            const matchesLocation =
                lowerLocation === '' ||
                (typeof city === 'string' && city.toLowerCase().includes(lowerLocation)) ||
                (typeof province === 'string' && province.toLowerCase().includes(lowerLocation));

            const matchesOpportunity =
                trimmedOpportunity === '' ||
                opportunityNumber.includes(trimmedOpportunity);

            const matchesOpportunityType =
                lowerSelectedOpportunity === '' ||
                (typeof opportunityType === 'string' &&
                    opportunityType.toLowerCase().includes(lowerSelectedOpportunity));

            let matchesDate = true;
            if (selectedStartDate && rowDate) {
                if (selectedStartDate === 'Today') {
                    matchesDate = rowDate.isSame(today, 'day');
                } else if (selectedStartDate === 'Next 7 Days') {
                    // matchesDate = rowDate.isSameOrAfter(today) && rowDate.isSameOrBefore(moment().add(7, 'days'));
                    matchesDate =
                        rowDate.isSameOrAfter(today) &&
                        rowDate.isSameOrBefore(moment().tz(tz).add(7, 'days').endOf('day'));
                } else if (selectedStartDate === 'Next 14 Days') {
                    // matchesDate = rowDate.isSameOrAfter(today) && rowDate.isSameOrBefore(moment().add(14, 'days'));
                    matchesDate =
                        rowDate.isSameOrAfter(today) &&
                        rowDate.isSameOrBefore(moment().tz(tz).add(14, 'days').endOf('day'));
                }
            }

            let matchesWage = true;
            if (selectedWage && row.wage != null) {
                const wageInDollars = Number(row.wage) / 100;

                if (selectedWage === 'Up to $30') {
                    matchesWage = wageInDollars <= 30;
                } else if (selectedWage === '$30 to $50') {
                    matchesWage = wageInDollars > 30 && wageInDollars <= 50;
                } else if (selectedWage === '$50 to $70') {
                    matchesWage = wageInDollars > 50 && wageInDollars <= 70;
                } else if (selectedWage === '$70+') {
                    matchesWage = wageInDollars > 70;
                }
            }

            return (
                matchesRole &&
                matchesLocation &&
                matchesOpportunity &&
                matchesOpportunityType &&
                matchesDate &&
                matchesWage &&
                matchesIndustry
            );
        });

        setRows(filtered);
        setPage(0);
    };



   const handleIndustryChange = (value: string) => {
    setSelectedIndustryMode(value);
    industryParam = value; // update the param variable
    const searchParams = new URLSearchParams(location.search);
    if (value === '') {
        searchParams.delete('industry');
         handleSearchWithValues({
               role: roleSearch,
               location: locationSearch,
               opportunity: opportunitySearch,
               selectedRole: '',
               selectedStartDate,
               selectedOpportunity,
               selectedWage,
               selectedIndustryMode:''
           });
        }
    else searchParams.set('industry', value);
    history.replace({ pathname: location.pathname, search: searchParams.toString() });
    
};

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </div>
        );
    }
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleSort = (property: string) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };


    const paginatedRows = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    return (
        <>
            <style>
                {`
  html, body, #root {
  height: 100%;
}
body {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
  `}
            </style>
            <div className={classes.container}>
                <RBCardView
                    className={classes.formContainer}
                    style={{
                        border: `2px solid ${secondaryColor || '#ccc'}`,
                        borderRadius: 8,
                    }}
                >
                    {brandDetail?.emailLogo && (
                        <div
                            className={classes.logoWrapper}
                        >
                            <img
                                src={brandDetail.emailLogo}
                                alt="logo"
                                className={classes.logo}

                            />
                        </div>
                    )}

                    <Typography variant="h4" gutterBottom className={classes.heading} >
                        Open Opportunities
                    </Typography>

                    <Typography variant="body1" color="textSecondary" className={classes.topText}>

                        <a target="_blank" href={networkId ? `/invite/${networkId}?code=RB-JobBoard`: `/invite/7b89c1df-df98-41e8-a06c-f3d1d748de84?code=RB-JobBoard`} style={{ color: "#3777a9", textDecoration: "underline", cursor: "pointer" }}>Sign Up</a> to view the complete details and apply!
                        If you’re already a member open the Relief Buddy mobile app.
                        Prefer to use your Desktop - <a target="_blank" href={`/signIn`} style={{ color: "#3777a9", textDecoration: "underline", cursor: "pointer" }}>Sign In</a>.

                    </Typography>


                    <Box
                        display="flex"
                        flexWrap="wrap"
                        justifyContent="center"
                        alignItems="center"
                        bgcolor="#f6f6f6"
                        p={2}
                        borderRadius={8}
                        boxShadow={1}
                    >
                        <TextField
                            placeholder="Role"
                            variant="outlined"
                            size="small"
                            value={roleSearch}
                            className={`${classes.textField} ${classes.filterItem}`}
                            onChange={(e) => setRoleSearch(e.target.value)}
                            style={{
                                minWidth: 280,
                                margin: 8,
                                backgroundColor: 'white',
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" color="action" />
                                    </InputAdornment>
                                ),
                                endAdornment: roleSearch && (
                                    <InputAdornment position="end">
                                        <IconButton size="small"
                                            onClick={() => {
                                                const clearedValue = '';
                                                setRoleSearch(clearedValue);
                                                handleSearchWithValues({
                                                    role: clearedValue,
                                                    location: locationSearch,
                                                    opportunity: opportunitySearch,
                                                    selectedRole,
                                                    selectedStartDate,
                                                    selectedOpportunity,
                                                    selectedWage,
                                                    selectedIndustryMode
                                                });
                                            }}
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            InputLabelProps={{ shrink: true }}
                        />

                        <TextField
                            placeholder="City or Province"
                            variant="outlined"
                            size="small"
                            value={locationSearch}
                            className={`${classes.textField} ${classes.filterItem}`}
                            onChange={(e) => setLocationSearch(e.target.value)}
                            style={{
                                minWidth: 280,
                                margin: 8,
                                backgroundColor: 'white',
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <RoomIcon fontSize="small" color="action" />
                                    </InputAdornment>
                                ),
                                endAdornment: locationSearch && (
                                    <InputAdornment position="end">
                                        <IconButton size="small"
                                            onClick={() => {
                                                const clearedValue = '';
                                                setLocationSearch(clearedValue);
                                                handleSearchWithValues({
                                                    role: roleSearch,
                                                    location: clearedValue,
                                                    opportunity: opportunitySearch,
                                                    selectedRole,
                                                    selectedStartDate,
                                                    selectedOpportunity,
                                                    selectedWage,
                                                    selectedIndustryMode
                                                });
                                            }}
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            InputLabelProps={{ shrink: true }}
                        />

                        <Button
                            variant="contained"
                            color="primary"
                            className={`${classes.button} ${classes.filterItem}`}
                            onClick={() =>
                                handleSearchWithValues({
                                    role: roleSearch,
                                    location: locationSearch,
                                    opportunity: opportunitySearch,
                                    selectedRole,
                                    selectedStartDate,
                                    selectedOpportunity,
                                    selectedWage,
                                    selectedIndustryMode
                                })
                            }
                        >
                            Find Opportunities
                        </Button>
                    </Box>
                    <Paper elevation={1} style={{ paddingLeft: isMobile ? 10 : 40, paddingRight: 25, marginBottom: 32, paddingBottom: 20 }}>
                        <Box
                            display="flex"
                            flexDirection={{ xs: 'column', sm: 'row' }}
                            flexWrap="wrap"
                            style={{ margin: -8, }}
                        >
                            {[
                                <TextField
                                    fullWidth
                                    label="Opportunity #"
                                    value={opportunitySearch}
                                    variant="standard"
                                    className={`${classes.textField} ${classes.filterItem}`}
                                    onChange={(e) => setOpportunitySearch(e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon fontSize="small" color="action" />
                                            </InputAdornment>
                                        ),
                                        endAdornment: opportunitySearch && (
                                            <InputAdornment position="end">
                                                <IconButton size="small"
                                                    onClick={() => {
                                                        const cleared = '';
                                                        setOpportunitySearch(cleared);
                                                        handleSearchWithValues({
                                                            role: roleSearch,
                                                            location: locationSearch,
                                                            opportunity: cleared,
                                                            selectedRole,
                                                            selectedStartDate,
                                                            selectedOpportunity,
                                                            selectedWage,
                                                            selectedIndustryMode
                                                        });
                                                    }}
                                                >
                                                    <ClearIcon fontSize="small" />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />,
                                <FormControl fullWidth className={classes.filterItem}>
                                    <CustomInputLabel id="start-date-label" shrink={selectedStartDate !== ''} style={{ color: "grey" }}>Start Date</CustomInputLabel>
                                    <Select
                                        variant="standard"
                                        input={<CustomInput />}
                                        labelId="start-date-label"
                                        value={selectedStartDate}
                                        onChange={(e) => {
                                            const value = e.target.value as string;
                                            setSelectedStartDate(value);

                                            if (value === '') {
                                                handleSearchWithValues({
                                                    role: roleSearch,
                                                    location: locationSearch,
                                                    opportunity: opportunitySearch,
                                                    selectedRole,
                                                    selectedStartDate: '',
                                                    selectedOpportunity,
                                                    selectedWage,
                                                    selectedIndustryMode
                                                });
                                            }
                                        }}
                                        label="Start Date"
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 250, // limit dropdown height
                                                    marginTop: isMobile ? 34 : 0,
                                                    minWidth: isMobile ? 300 : undefined, // ✅ override minWidth
                                                    overflow: 'auto'
                                                },
                                            },
                                            MenuListProps: {
                                                style: {
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem value="">
                                            Select
                                        </MenuItem>
                                        {['Today', 'Next 7 Days', 'Next 14 Days'].map((label) => (
                                            <MenuItem value={label} key={label}>
                                                {label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>,
                                <FormControl fullWidth className={classes.filterItem}>
                                    <CustomInputLabel id="opportunity-type-label" shrink={selectedOpportunity !== ''} style={{ color: "grey" }}>Opportunity Type</CustomInputLabel>
                                    <Select
                                        variant="standard"
                                        input={<CustomInput />}
                                        labelId="opportunity-type-label"
                                        value={selectedOpportunity}
                                        onChange={(e) => {
                                            const value = e.target.value as string;
                                            setSelectedOpportunity(value);

                                            if (value === '') {
                                                handleSearchWithValues({
                                                    role: roleSearch,
                                                    location: locationSearch,
                                                    opportunity: opportunitySearch,
                                                    selectedRole,
                                                    selectedStartDate,
                                                    selectedOpportunity: '',
                                                    selectedWage,
                                                    selectedIndustryMode
                                                });
                                            }
                                        }}
                                        label="Opportunity Type"
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 250, // limit dropdown height
                                                    marginTop: isMobile ? 34 : 0,
                                                    minWidth: isMobile ? 300 : undefined, // ✅ override minWidth
                                                    overflow: 'auto'
                                                },
                                            },
                                            MenuListProps: {
                                                style: {
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem value="">
                                            Select
                                        </MenuItem>
                                        {opportunityOptions.map(({ label, value }) => (
                                            <MenuItem key={value} value={value}>
                                                {label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>,
                                <FormControl fullWidth className={classes.filterItem} >
                                    <CustomInputLabel id="role-select-label" shrink={selectedRole !== ''} style={{ color: "grey" }}>Role</CustomInputLabel>
                                    <Select
                                        labelId="role-select-label"
                                        value={selectedRole}
                                        variant="standard"
                                        input={<CustomInput />}
                                        onChange={(e) => {
                                            const value = e.target.value as string;
                                            setSelectedRole(value);

                                            if (value === '') {
                                                handleSearchWithValues({
                                                    role: roleSearch,
                                                    location: locationSearch,
                                                    opportunity: opportunitySearch,
                                                    selectedRole: '',
                                                    selectedStartDate,
                                                    selectedOpportunity,
                                                    selectedWage,
                                                    selectedIndustryMode
                                                });
                                            }
                                        }}
                                        label="Role"
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 250, // limit dropdown height
                                                    marginTop: isMobile ? 34 : 0,
                                                    minWidth: isMobile ? 300 : undefined, // ✅ override minWidth
                                                    overflow: 'auto'
                                                },
                                            },
                                            MenuListProps: {
                                                style: {
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem value="">
                                            Select
                                        </MenuItem>
                                        {roles.map((value) => (
                                            <MenuItem value={(value as any).acronym ? (value as any).acronym : value.displayName} key={value.workerType}>
                                                {value.displayName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>,
                                <FormControl fullWidth className={classes.filterItem}>
                                    <CustomInputLabel id="wage-label" shrink={selectedWage !== ''} style={{ color: "grey" }}>Wage</CustomInputLabel>
                                    <Select
                                        variant="standard"
                                        input={<CustomInput />}
                                        labelId="wage-label"
                                        value={selectedWage}
                                        onChange={(e) => {
                                            const value = e.target.value as string;
                                            setSelectedWage(value);

                                            if (value === '') {
                                                handleSearchWithValues({
                                                    role: roleSearch,
                                                    location: locationSearch,
                                                    opportunity: opportunitySearch,
                                                    selectedRole,
                                                    selectedStartDate,
                                                    selectedOpportunity,
                                                    selectedWage: '',
                                                    selectedIndustryMode
                                                });
                                            }
                                        }}
                                        label="Wage"
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200, // limit dropdown height
                                                    marginTop: isMobile ? 34 : 0,
                                                    minWidth: isMobile ? 300 : undefined, // ✅ override minWidth
                                                    overflow: 'auto'
                                                },
                                            },
                                            MenuListProps: {
                                                style: {
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem value="">
                                            Select
                                        </MenuItem>
                                        {['Up to $30', '$30 to $50', '$50 to $70', '$70+'].map((label) => (
                                            <MenuItem value={label} key={label}>
                                                {label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>,

                                 !networkId &&
                                 <FormControl fullWidth className={classes.filterItem} >
                                    <CustomInputLabel id="role-select-label" shrink={selectedIndustryMode !== ''} style={{ color: "grey" }}>Industry</CustomInputLabel>
                                    <Select
                                        labelId="role-select-label"
                                        value={selectedIndustryMode}
                                        variant="standard"
                                        input={<CustomInput />}
                                         onChange={(e) => handleIndustryChange(e.target.value as string)}
                                        label="Industry"
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 250, // limit dropdown height
                                                    marginTop: isMobile ? 34 : 0,
                                                    minWidth: isMobile ? 300 : undefined, // ✅ override minWidth
                                                    overflow: 'auto'
                                                },
                                            },
                                            MenuListProps: {
                                                style: {
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem value="">
                                            Select
                                        </MenuItem>
                                        {industryModes.map((value) => (
                                            <MenuItem value={value.industryMode} key={value.industryMode}>
                                                {value.displayName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>,

                            ].map((child, index) => (
                                <Box
                                    key={index}
                                    minWidth={{ xs: '100%', sm: 200 }}
                                    maxWidth={250}
                                    width={{ xs: '100%', sm: '100%' }}
                                    style={{ margin: 8 }} // ✅ This ensures spacing between items
                                >
                                    {child}
                                </Box>
                            ))}
                        </Box>
                    </Paper>

                    {hasError ? (
                        <Box mt={4} mb={4} textAlign="center">
                            <Typography variant="h6" color="error" gutterBottom>
                                Oops! Looks like we can’t get the list of opportunities.
                            </Typography>
                            <Typography variant="body1" color="textSecondary">
                                Our team is looking into this. Please check back shortly as we work on resolving the issue.
                            </Typography>
                        </Box>
                    ) : (
                        <div style={{ width: '100%', overflowX: 'auto', boxSizing: 'border-box' }}>
                            <TableContainer component={Paper}
                                style={{
                                    width: isMobile ? 400 : "100%",
                                    maxHeight: 650,
                                }}>
                                <Table stickyHeader size="small">
                                    <TableHead>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    sortDirection={orderBy === column.id ? order : false}
                                                    style={{ minWidth: 120, fontWeight: 'bold', backgroundColor: 'lightgrey' }}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === column.id}
                                                        direction={orderBy === column.id ? order : 'asc'}
                                                        onClick={() => handleSort(column.id)}
                                                    >
                                                        {column.label}
                                                    </TableSortLabel>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={columns.length} align="center">
                                                    No data found
                                                </TableCell>
                                            </TableRow>
                                        ) : ([...rows]
                                            .sort((a, b) => {
                                                if (orderBy === 'startDate') {
                                                    const aDate = a.rawDate ? new Date(a.rawDate).getTime() : 0;
                                                    const bDate = b.rawDate ? new Date(b.rawDate).getTime() : 0;
                                                    return order === 'asc' ? aDate - bDate : bDate - aDate;
                                                }

                                                const aVal = a[orderBy as keyof OpportunityRow];
                                                const bVal = b[orderBy as keyof OpportunityRow];

                                                const aStr = aVal != null ? aVal.toString() : '';
                                                const bStr = bVal != null ? bVal.toString() : '';

                                                return order === 'asc'
                                                    ? aStr.localeCompare(bStr, undefined, { numeric: true })
                                                    : bStr.localeCompare(aStr, undefined, { numeric: true });
                                            })
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row, i) => (
                                                <TableRow key={i}>
                                                    {columns.map((column) => (
                                                        <TableCell key={column.id}>
                                                            {row[column.id as keyof OpportunityRow]}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={rows.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                        </div>
                    )}


                    <Typography variant="body1" color="textSecondary" className={classes.bottomText}>
                        Interested in any of these opportunities? Download the <b>Relief Buddy</b> App now and <a target="_blank" href={networkId ? `/invite/${networkId}?code=RB-JobBoard`: `/invite/7b89c1df-df98-41e8-a06c-f3d1d748de84?code=RB-JobBoard`} style={{ color: "#3777a9", textDecoration: "underline", cursor: "pointer" }}>Sign Up</a> , it’s free to join!
                        Interested in posting your Opportunity here? Contact us for more details: <a href="mailto:info@ReliefBuddy.com?subject=Interested%20In%20The%20Relief%20Buddy%20Job%20Board" style={{ color: "#3777a9", textDecoration: "underline", cursor: "pointer" }}>info@ReliefBuddy.com</a>

                    </Typography>


                    <div style={{ textAlign: 'center', }}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: 10,
                                flexWrap: 'nowrap', // ⛔ don't wrap to next line
                                padding: '0 10px', // ✅ optional padding for edges
                            }}
                        >
                            <a
                                href="https://apps.apple.com/ca/app/relief-buddy/id1252239337"
                                style={{ textDecoration: 'none' }}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src="https://relief-buddy-production.s3.ca-central-1.amazonaws.com/images/RB_appstore_download.png"
                                    width="180"   // decreased from 250
                                    height="110"  // decreased from 150
                                    alt="Download on the App Store"
                                />
                            </a>

                            <a
                                href="https://play.google.com/store/apps/details?id=com.reliefbuddy.ca"
                                style={{ textDecoration: 'none' }}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src="https://relief-buddy-production.s3.ca-central-1.amazonaws.com/images/RB_playstore_download.png"
                                    width="180"
                                    height="110"
                                    alt="Get it on Google Play"
                                />
                            </a>
                        </div>

                        <div style={{ lineHeight: '1.2', marginTop: -20, fontSize: 14, marginBottom: 5 }}> {/* reduced from 0 to 10 */}
                            Powered by Relief Buddy Inc.
                        </div>
                    </div>
                </RBCardView>
            </div>
        </>
    )

};


